// extracted by mini-css-extract-plugin
export default {"popperWrap":"GuideBaseWithLuffy_popperWrap__Ca0SG"};